var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"competition-container"},[_c('module1'),_c('module2',{ref:"competition2"}),_c('module3',{ref:"competition3"}),_c('module5',{ref:"competition5"}),_c('module4')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }